function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "1.235%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#383C4B"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#171921"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "url(#a)"
}), React.createElement("path", {
  fill: "#FFCB6F",
  d: "M24.094 21.548h-10.76v-1.992h10.76z"
}), React.createElement("path", {
  fill: "#FFB917",
  d: "M28.477 15.326H13.333v-1.993h15.144z"
}), React.createElement("path", {
  fill: "#FEDEA7",
  d: "M20.905 27.77h-7.572v-1.992h7.572z"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/pro-copy-3.76d7939a.svg";
export { SvgComponent as ReactComponent };